import { ChangeDetectionStrategy, Component, computed, input, linkedSignal, output } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { GallerySettingsCustomizeHeaderComponent } from '../gallery-settings-customize-header/gallery-settings-customize-header.component';
import { ThemeCoverDescriptionItemComponent } from '../theme-cover-description-item/theme-cover-description-item.component';
import { ThemeCoverTitleItemComponent } from '../theme-cover-title-item/theme-cover-title-item.component';
import { ThemeHeadingsItemComponent } from '../theme-headings-item/theme-headings-item.component';
import { ThemeParagraphsItemComponent } from '../theme-paragraphs-item/theme-paragraphs-item.component';

@Component({
  selector: 'app-theme-typography-customize',
  imports: [
    GallerySettingsCustomizeHeaderComponent,
    ThemeCoverTitleItemComponent,
    ThemeCoverTitleItemComponent,
    ThemeCoverDescriptionItemComponent,
    ThemeHeadingsItemComponent,
    ThemeParagraphsItemComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-typography-customize.component.html',
  styleUrl: './theme-typography-customize.component.scss',
})
export class ThemeTypographyCustomizeComponent {
  gallery = input.required<GalleryDto>();
  defaultOpenTypographyMenu = input<string>();
  theme = computed(() => {
    const gallery = this.gallery();
    if (!gallery) return;
    return gallery.theme || calcLegacyTheme(gallery);
  });
  back = output<void>();
  openToggler = linkedSignal(() => this.defaultOpenTypographyMenu() || 'coverTitle');
}
